import { accessRole } from '../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'

class IndexView extends Component {

    createBloc = new CreateBloc();

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {}
        }
    }

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              employee_uuid : this.peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })       
    }

    componentWillUnmount(){
        this.createBloc.createChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="pengalaman_kerja"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Tambah Pengalaman Kerja Sebelum CPNS</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="date_of_birth"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Mulai Kerja <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="work_experience_date"
                                                    placeholder="Tanggal Mulai Kerja..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Mulai Kerja"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="work_experience_date"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="work_experience_agency"
                                                className="col-md-3 col-form-label"
                                            >
                                            Instansi/Perusahaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="work_experience_agency"
                                                    placeholder="Instansi/Perusahaan..."
                                                    type="text"
                                                    errorMessage="Masukkan Instansi/Perusahaan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="work_experience_agency"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="work_experience_field_of_work"
                                                className="col-md-3 col-form-label"
                                            >
                                            Bidang/Spesifikasi Pekerjaan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="work_experience_field_of_work"
                                                    placeholder="Bidang/Spesifikasi Pekerjaan..."
                                                    type="text"
                                                    errorMessage="Masukkan Bidang/Spesifikasi Pekerjaan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="work_experience_field_of_work"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="work_experience_position"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jabatan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="work_experience_position"
                                                    placeholder="Jabatan..."
                                                    type="text"
                                                    errorMessage="Masukkan Jabatan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="work_experience_position"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="work_experience_year"
                                                className="col-md-3 col-form-label"
                                            >
                                            Masa Kerja (Tahun) <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="work_experience_year"
                                                    placeholder="Masa Kerja (Diisi Jumlah Tahun)..."
                                                    type="number"
                                                    errorMessage="Masukkan Masa Kerja (Tahun)"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="work_experience_year"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="work_experience_month"
                                                className="col-md-3 col-form-label"
                                            >
                                            Masa Kerja (Bulan) <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="work_experience_month"
                                                    placeholder="Masa Kerja (Diisi Jumlah Bulan)..."
                                                    type="number"
                                                    errorMessage="Masukkan Masa Kerja (Bulan)"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="work_experience_month"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="work_experience_description"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="work_experience_description"
                                                    placeholder="Keterangan..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Keterangan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="work_experience_description"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>
                                                
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?pengalaman_kerja">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?pengalaman_kerja'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView